import {
    ADDITIONAL_MEDICAL_INFORMATION_ENDPOINT,
    MEDICAL_INFORMATION_ENDPOINT,
} from "../../endpoints";
import { fetcher } from "../../utils";
import {
    convertAdvancedMedicalInfoFromAPI,
    convertBasicMedicalInfoFromAPI,
    invertAdvancedMedicalInfoData,
    invertBasicMedicalInfoData,
} from "./converters";
import { AdvancedMedicalInfo, BasicMedicalInfo } from "./types";

export const getBasicMedicalInfo = async ({ testId }: { testId: string }) => {
    const response = await fetcher(MEDICAL_INFORMATION_ENDPOINT, {
        params: { test_id: testId },
    });

    return convertBasicMedicalInfoFromAPI(response);
};

export const submitBasicMedicalInfo = async ({
    testId,
    values,
}: {
    testId: string;
    values: BasicMedicalInfo;
}) => {
    const response = await fetcher(
        MEDICAL_INFORMATION_ENDPOINT,
        {
            method: "PUT",
            params: { test_id: testId },
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(invertBasicMedicalInfoData(values)),
        },
        true
    );

    return convertBasicMedicalInfoFromAPI(response);
};

export const getAdvancedMedicalInfo = async ({
    testId,
}: {
    testId: string;
}) => {
    const response = await fetcher(ADDITIONAL_MEDICAL_INFORMATION_ENDPOINT, {
        params: { test_id: testId },
    });

    return convertAdvancedMedicalInfoFromAPI(response);
};

export const submitAdvancedMedicalInfo = async ({
    testId,
    values,
}: {
    testId: string;
    values: AdvancedMedicalInfo;
}) => {
    const response = await fetcher(
        ADDITIONAL_MEDICAL_INFORMATION_ENDPOINT,
        {
            method: "PUT",
            params: { test_id: testId },
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(invertAdvancedMedicalInfoData(values)),
        },
        true
    );

    return convertAdvancedMedicalInfoFromAPI(response);
};
